// extracted by css-extract-rspack-plugin
export default {"loadingBanner":"_e748d35"};